var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("table", { staticClass: "table rate-table" }, [
    _vm._m(0),
    _vm._v(" "),
    _c(
      "tbody",
      [
        _c("tr", [
          _vm._m(1),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm.config.site_name))])
        ]),
        _vm._v(" "),
        _vm.reservation.date_pickup !== null &&
        _vm.reservation.date_return !== null
          ? _c("tr", [
              _vm._m(2),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm.rental_dates_formatted))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c("strong", [
              _vm._v("Ski Rental"),
              _vm.reservation.date_pickup !== null &&
              _vm.reservation.date_return !== null &&
              !_vm.reservation.is_seasonal
                ? _c("span", [_vm._v(" (" + _vm._s(_vm.rental_timespan) + ")")])
                : _vm._e(),
              _vm._v(":")
            ])
          ]),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.total_packages_price)))])
        ]),
        _vm._v(" "),
        _c("tr", [
          _vm._m(3),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.total_addon_price)))])
        ]),
        _vm._v(" "),
        _vm.is_buddy_service_enabled &&
        _vm.cost.total_addon_price_buddy_insurance
          ? _c("tr", [
              _vm._m(4),
              _vm._v(" "),
              _c("td", [
                _vm._v(
                  _vm._s(_vm._money(_vm.cost.total_addon_price_buddy_insurance))
                )
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.cost.special_days_amount
          ? _c("tr", [
              _c("td", [
                _c("strong", [
                  _vm._v(
                    "Special period increase ( " +
                      _vm._s(_vm.cost.special_period_days_count) +
                      " Days):"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("td", [
                _vm._v(_vm._s(_vm._money(_vm.cost.special_days_amount)))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _vm._m(5),
          _vm._v(" "),
          _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.sub_total)))])
        ]),
        _vm._v(" "),
        _vm.cost.saved_by_coupon > 0
          ? _c("tr", [
              _vm._m(6),
              _vm._v(" "),
              _c("td", { staticClass: "red--text" }, [
                _vm._v(_vm._s(_vm._money(_vm.cost.saved_by_coupon)))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.cost.book_me_discount && _vm.cost.book_me_discount.discount > 0
          ? _c("tr", [
              _c("td", [
                _c("strong", [
                  _vm._v(
                    _vm._s(_vm.cost.book_me_discount.name) +
                      " Discount(" +
                      _vm._s(_vm.cost.book_me_discount.percentage) +
                      "%):"
                  )
                ])
              ]),
              _vm._v(" "),
              _c("td", { staticClass: "red--text" }, [
                _vm._v(_vm._s(_vm._money(_vm.cost.book_me_discount.discount)))
              ])
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm.is_international_canadian
          ? [
              _c("tr", [
                _c("td", [
                  _c("strong", [
                    _vm._v("Tax: ( PST: " + _vm._s(_vm.sales_tax_pst) + "% )")
                  ])
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.pst_tax_amount)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("td", [
                  _c("strong", [
                    _vm._v("Tax: ( GST: " + _vm._s(_vm.sales_tax_gst) + "% )")
                  ])
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.gst_tax_amount)))])
              ])
            ]
          : [
              _c("tr", [
                _c("td", [
                  _c("strong", [
                    _vm._v("Tax: ( " + _vm._s(_vm.cost.tax_percent) + "% )")
                  ])
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.tax_amount)))])
              ])
            ],
        _vm._v(" "),
        parseInt(_vm.config.special_fee_at_checkout) == 1
          ? _c("tr", [
              _c("td", [
                _c("strong", [
                  _vm._v(_vm._s(_vm.config.special_fee_label) + ":")
                ])
              ]),
              _vm._v(" "),
              _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.special_fee)))])
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("tr", [
          _c("td", [
            _c(
              "strong",
              [
                _vm.securitydeposit &&
                _vm.reservation.is_seasonal &&
                _vm.frontend_view_folder == "frontend.highcountryskiandtennis"
                  ? [_vm._v("Total Rental")]
                  : [_vm._v("Total Cost")],
                _vm._v(" "),
                !isNaN(_vm.rental_timespan)
                  ? _c("span", [
                      _vm._v(" (" + _vm._s(_vm.rental_timespan) + ")")
                    ])
                  : _vm._e(),
                _vm._v(":")
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("td", [
            _vm._v(
              _vm._s(_vm._money(_vm.cost.total_price - _vm.cost.deposit_total))
            )
          ])
        ]),
        _vm._v(" "),
        _vm.securitydeposit &&
        _vm.reservation.is_seasonal &&
        _vm.frontend_view_folder == "frontend.highcountryskiandtennis"
          ? [
              _c("tr", [
                _vm._m(7),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.deposit_total)))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _vm._m(8),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm._money(_vm.cost.total_price)))])
              ])
            ]
          : _vm._e()
      ],
      2
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", { attrs: { colspan: "2" } }, [_vm._v("Rental Information")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Rental Location:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Rental Dates:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Add-on Total:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Buddy Price:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Sub Total:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Discount:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Deposit:")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", [_c("strong", [_vm._v("Total:")])])
  }
]
render._withStripped = true

export { render, staticRenderFns }